import React from 'react';
import Info from '../../info';

export default function RightPanelBottom() {
  return <Info paragraphs={[APP.LANGUAGE.SendConsultNowInvitation.InfoPart]} />;
}
